import InvestorInvitationCreateRequestResource from "common/resources/InvestorInvitation/InvestorInvitationCreateRequestResource";
import InvestorInvitationLinkResponseResource from "common/resources/InvestorInvitation/InvestorInvitationLinkResponseResource";
import InvestorInvitationLinkValueResponseResource from "common/resources/InvestorInvitation/InvestorInvitationLinkValueResponseResource";
import InvestorInvitationProductResponseResource from "common/resources/InvestorInvitation/InvestorInvitationProductResponseResource";
import InvestorInvitationResponseResource from "common/resources/InvestorInvitation/InvestorInvitationResponseResource";
import { singleton } from "tsyringe";

import BaseApi from "./BaseApi";

/** Invitations du portail investisseur, côté conseiller (voir docs/portail-investisseur.md). */
@singleton()
export default class InvestorInvitationApi extends BaseApi {
	private readonly baseUrl = `${this.apiUrl}/investor-invitations`;

	public async getAll() {
		return this.getRequest<InvestorInvitationResponseResource[]>(this.baseUrl);
	}

	public async getProducts() {
		return this.getRequest<InvestorInvitationProductResponseResource[]>(`${this.baseUrl}/products`);
	}

	public async create(body: InvestorInvitationCreateRequestResource) {
		return this.postRequest<InvestorInvitationLinkResponseResource>(this.baseUrl, { ...body });
	}

	public async getLink(id: string) {
		return this.getRequest<InvestorInvitationLinkValueResponseResource>(`${this.baseUrl}/${id}/link`);
	}

	public async resend(id: string) {
		return this.postRequest<InvestorInvitationLinkResponseResource>(`${this.baseUrl}/${id}/resend`);
	}

	public async revoke(id: string) {
		return this.postRequest<InvestorInvitationResponseResource>(`${this.baseUrl}/${id}/revoke`);
	}
}
